export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-500">有网红黑料线索？欢迎投稿爆料，你的信息将被严格保密</p>
          </div>

          <div className="max-w-xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-5 rounded-xl bg-background-200/70 border border-background-300/40 text-center cursor-pointer hover:border-primary-500/30 transition-all duration-300">
                <span className="w-10 h-10 flex items-center justify-center mx-auto text-primary-500">
                  <i className="ri-mail-line text-2xl"></i>
                </span>
                <p className="mt-3 text-sm font-medium text-foreground-800">投稿邮箱</p>
                <p className="mt-1 text-xs text-foreground-400">tips@wanghong.news</p>
              </div>
              <div className="p-5 rounded-xl bg-background-200/70 border border-background-300/40 text-center cursor-pointer hover:border-primary-500/30 transition-all duration-300">
                <span className="w-10 h-10 flex items-center justify-center mx-auto text-accent-500">
                  <i className="ri-wechat-line text-2xl"></i>
                </span>
                <p className="mt-3 text-sm font-medium text-foreground-800">微信客服</p>
                <p className="mt-1 text-xs text-foreground-400">wanghong_news</p>
              </div>
              <div className="p-5 rounded-xl bg-background-200/70 border border-background-300/40 text-center cursor-pointer hover:border-primary-500/30 transition-all duration-300">
                <span className="w-10 h-10 flex items-center justify-center mx-auto text-secondary-500">
                  <i className="ri-shield-check-line text-2xl"></i>
                </span>
                <p className="mt-3 text-sm font-medium text-foreground-800">爆料须知</p>
                <p className="mt-1 text-xs text-foreground-400">信息加密 · 匿名保护</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}